'use strict';

var _ = require('lodash');
var d3 = require('d3');

/**
 * Simple Bars
 *
 * Renders simple bars
 *
 * @returns {Function}
 * @constructor
 */
var BarSeries = function BarSeries() {
  /**
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (yPropertyNames) {
    var params, scales;
    var barFillFactory = 0.8;

    /**
     *
     * @param container
     */
    var bars = function bars(container) {
      var spaceForOneBar = Math.round(scales.xScale.rangeBand() / yPropertyNames.length);
      var barWidth = Math.round(spaceForOneBar * barFillFactory);
      var prefix = (spaceForOneBar - barWidth) / 2;
      var group = container.select('.groups').selectAll('.stack.visible');
      _.each(yPropertyNames, function (yPropertyName, serieId) {
        var selector = yPropertyName + '-bar';
        group.each(function (d) {
          if (d[yPropertyName] !== undefined) {
            var simpleBars = d3.select(this).selectAll('.' + selector).data([d]);
            simpleBars.enter().append('rect');
            simpleBars.attr({
              'class': function _class(d) {
                return selector + ' simple-bar' + (d[yPropertyName] < 0 ? ' negative-value' : '');
              },
              'x': spaceForOneBar * serieId + prefix,
              'y': function y(d) {
                return scales.yScale(Math.max(d[yPropertyName], 0));
              },
              'width': barWidth,
              'height': function height(d) {
                return Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyName]));
              }
            }).style({
              'fill': function fill(d) {
                return d.fill;
              }
            });
          }
        });
      });
    };

    /**
     *  Setters and getters
     */

    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    return bars;
  };
};
BarSeries.$inject = [];
module.exports = BarSeries;